import { ValueLabel } from '../common';
import { ICsaRequestStatus } from '.';
import { pathOr } from 'rambda';
import { contramap } from 'fp-ts/Ord';
import * as S from 'fp-ts/string';
import { pipe } from 'fp-ts/function';

export interface ICsaSearchableProperty
  extends ValueLabel<keyof ICsaRequestStatus> {
  searchable: boolean;
}

export const sortable =
  (propertyMap: Record<'status', string>) => (name: string) =>
    pathOr('', name)(propertyMap) !== '';

export const byLabel = pipe(S.Ord, contramap(pathOr('', 'label')));

export const csaProperties: ICsaSearchableProperty[] = [
  { value: 'id', label: 'Request ID', searchable: true },

  { value: 'createdAt', label: 'Created Date', searchable: true },
  { value: 'updateDatetime', label: 'Updated Date', searchable: true },
  { value: 'deaRetdt', label: 'deaRetdt', searchable: true },
  { value: 'deaExpdt', label: 'deaExpdt', searchable: false },

  { value: 'status', label: 'Status', searchable: true },
  {
    value: 'sailpointRequestId',
    label: 'Sailpoint Request ID',
    searchable: true,
  },
  {
    value: 'deanum',
    label: 'DEA Number',
    searchable: true,
  },
  {
    value: 'taxId',
    label: 'Tax ID',
    searchable: true,
  },
  {
    value: 'registrantLastNameBussName',
    label: 'Business',
    searchable: true,
  },
  {
    value: 'registrantFirstName',
    label: 'Business First Name',
    searchable: true,
  },
  {
    value: 'registrantPhoneNum',
    label: 'Business Phone',
    searchable: true,
  },
  {
    value: 'registrantPocEmail',
    label: 'registrantPocEmail',
    searchable: true,
  },
  {
    value: 'busact',
    label: 'busact',
    searchable: true,
  },
  {
    value: 'csaCode',
    label: 'csaCode',
    searchable: true,
  },
  {
    value: 'actionBy',
    label: 'actionBy',
    searchable: true,
  },
];
